/**
 * @flow
 * /

/** TODO: here we are getting error when gls is loaded here, so, we will debug that in v2 (tracker: https://tracker.apigateway.in/issues/2648) */

import React from 'react'
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import {
  isValidEmailIdWithOutRequired,
  isValidInternationalPhoneNumber,
  isRequired
} from '../../../../utils/FormValidations'
import { splitAddress } from '../../../../utils/googlePlacesUtils'
import { submitFormAPI } from '../../../../utils/forms.js'
import LocationSearchInput from './LocationSearchInput'

import './index.scss'

import {
  ApplyForFormSection,
  Heading,
  FormContainer,
  InputComponent,
  Button,
  SuccessText,
  PrimaryThankYouText,
  SecondaryThankYouText,
  ButtonWrapper,
  Loading,
  TextAreaComponent,
  WhyAreYouInterestedHeading,
  SuccessContainer,
  ResponsiveContainer
} from './styledComponents'

class ApplyForFranchiseAgentForm extends React.Component {
  static defaultProps = {
    required: 'Error',
    formHeading: 'Get in touch with one of our business executives!'
  }
  constructor(props) {
    super(props)
    this.state = {
      submissionStatus: false,
      address: '',
      city: '',
      state: '',
      country: '',
      latLng: ''
    }
  }

  clearTextInput = () => {
    this.nameRef.state.value = ''
    this.lastNameRef.state.value = ''
    this.phoneRef.state.value = ''
    this.emailRef.state.value = ''
    this.organizationRef.state.value = ''
    this.designationRef.state.value = ''
    this.whatAreYouLookingForRef.state.value = ''
    this.cityRef.clearValues()
    let form = document.getElementById('ExperientialMarketingForm')
    form.reset()
  }

  storeNameRef = ref => {
    this.nameRef = ref
  }
  storeLastNameRef = ref => {
    this.lastNameRef = ref
  }
  storeOrganisationRef = ref => {
    this.organizationRef = ref
  }
  storeWhatAreYouLookingForRef = ref => {
    this.whatAreYouLookingForRef = ref
  }
  storeDesignationRef = ref => {
    this.designationRef = ref
  }

  storeEmailRef = ref => {
    this.emailRef = ref
  }

  storePhoneRef = ref => {
    this.phoneRef = ref
  }

  storeOccupationRef = ref => {
    this.occupationRef = ref
  }

  storeCityRef = ref => {
    this.cityRef = ref
  }

  validateAllFields = () => {
    // NameValidation
    const nameValidationResponse = this.nameRef.validate()
    const isValidNameField = !nameValidationResponse.displayError
    // LastName validation
    const lastNameValidationResponse = this.lastNameRef.validate()
    const isValidLastNameField = !lastNameValidationResponse.displayError

    // EmailFieldValidation
    const emailValidationResponse = this.emailRef.validate()
    const isValidEmailField = !emailValidationResponse.displayError
    // PhoneValidation
    const phoneValidationResponse = this.phoneRef.validate()
    const isValidPhoneField = !phoneValidationResponse.displayError
    const organisationValidationResponse = this.organizationRef.validate()
    const isValidOrganisationField = !organisationValidationResponse.displayError

    const designationValidationResponse = this.designationRef.validate()
    const isValidDesignationField = !designationValidationResponse.displayError

    const cityValidationResponse = this.cityRef.validate()
    const isValidCityField = !cityValidationResponse.displayError

    const whatAreYouLookingForValidationResponse = this.whatAreYouLookingForRef.validate()
    const isValidWhatAreYouLookingForField = !whatAreYouLookingForValidationResponse.displayError

    // Languages Validation

    return (
      isValidNameField &&
      isValidLastNameField &&
      isValidPhoneField &&
      isValidEmailField &&
      isValidOrganisationField &&
      isValidDesignationField &&
      isValidCityField &&
      isValidWhatAreYouLookingForField
    )
  }

  goBack = () => {
    this.props.closeModal()
  }
  onFailureSubmitForm = () => {
    // TODO: Need to ask for UI to design team: @dependency on Anesh,Design
  }
  toCamelCase = name =>
    name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  submitForm = () => {
    // TODO: Add occupation specific values
    // const { address, city, state, country, latLng } = this.state
    const name = this.toCamelCase(this.nameRef.state.value)

    const formElement = document.getElementById('ExperientialMarketingForm')
    const htmlFormData = new FormData(formElement)
    const radioButtonGroupValue = htmlFormData.get('radio') //eslint-disable-line
    const { address, city, state, country, latLng } = this.state
    const formData = {
      First_Name: name,
      Last_Name: this.lastNameRef.state.value,
      Mobile_Number: this.phoneRef.state.value,
      Email_ID: this.emailRef.state.value,
      Designation: this.designationRef.state.value,
      Organisation: this.organizationRef.state.value,
      City: city,
      State: state,
      Country: country,
      Address: address,
      Latitude_Longitude: latLng,
      What_are_you_looking_to_create_together_with_iB_Cricket: this
        .whatAreYouLookingForRef.state.value
    }
    const requestObject = {
      submission_data: formData,
      form_unique_code: 'Experiential_Marketing'
    }
    submitFormAPI(
      requestObject,
      this.trackUser,
      () => {},
      this.onFailureSubmitForm
    )
    this.onFormSubmitSuccess()
  }

  mapFormDataAndSubmit = () => {
    const { address } = this.cityRef.state
    geocodeByAddress(address)
      .then(results => {
        this.setState({ address: results[0] })
        const addressValues = splitAddress(results[0])
        this.setState({ address: addressValues })
        getLatLng(results[0])
          .then(result => {
            this.setState({ latLng: JSON.stringify(result) })
            const { city, state, country } = addressValues
            this.setState({ city, state, country })
            this.submitForm()
          })
          .catch(error => {
            console.log('Lat long error', error)
          })
      })
      .catch(error => {
        console.log('error in getting address ', error)
      })
    return null
  }

  submitFormData = () => {
    const { address } = this.placesInputRef.state
    const { address: residenceAddress } = this.cityRef.state
    this.address = address
    this.city_of_residence_address = residenceAddress

    Promise.all([geocodeByAddress(address), geocodeByAddress(residenceAddress)])
      .then(([addressResutls, residenceAddressResults]) => {
        const addressValues = addressResutls[0]
        const residenceAddressValues = residenceAddressResults[0]
        if (this.addressValues !== 'undefined') {
          this.addressValues = addressValues
        }
        if (this.residenceAddressValues !== 'undefined') {
          this.residenceAddressValues = residenceAddressValues
        }
        return Promise.all([
          getLatLng(addressValues),
          getLatLng(residenceAddressValues)
        ])
      })
      .then(([franchiseLatLng, residenceLatLng]) => {
        this.franchiseLatLng = JSON.stringify(franchiseLatLng)
        this.residenceLatLng = JSON.stringify(residenceLatLng)
      })
      .catch(e => {
        const { PlacesServiceStatus } = window.google.maps.places
        switch (e) {
          case PlacesServiceStatus.ZERO_RESULTS:
            return
          case PlacesServiceStatus.OVER_QUERY_LIMIT:
          case PlacesServiceStatus.REQUEST_DENIED:
          case PlacesServiceStatus.INVALID_REQUEST:
          case PlacesServiceStatus.UNKNOWN_ERROR:
          default:
            throw e
        }
      })
      .then(() => {
        this.submitForm()
      })
      .catch(e => console.error(e))

    return null
  }

  onFormSubmitSuccess = () => {
    this.clearTextInput()
    this.setState({
      submissionStatus: true
    })
  }

  handleChange = () => {
    // TO remove ThankYou message after user changes
    this.setState({
      submissionStatus: false
    })
  }

  trackUser = () => {
    if (typeof fbq === 'function') {
      // this is for tracking analytics in fb
      fbq('track', 'ExperientialMarketingrequestsuccess', {}) // eslint-disable-line
    }
  }

  handleSubmitFn = () => {
    // Do validation
    const isValidForm = this.validateAllFields()
    if (isValidForm) {
      this.mapFormDataAndSubmit()
    }
  }

  handleSubmit = e => {
    if (e) {
      e.preventDefault()
    }
    const { showRadioError, didUserSelectRadio } = this.state
    if (!showRadioError && !didUserSelectRadio) {
      this.setState({ showRadioError: true })
    }
    this.handleSubmitFn()
  }

  render() {
    const { submissionStatus } = this.state
    const { formData, glsLoaded, required, formHeading } = this.props
    const {
      emailFieldPlaceholder,
      phoneNumberFieldPlaceholder
    } = formData[0].node.frontmatter
    if (submissionStatus) {
      return (
        <ResponsiveContainer>
          <SuccessContainer>
            <SuccessText submitted={submissionStatus}>
              <PrimaryThankYouText
                dangerouslySetInnerHTML={{
                  __html: 'Thank you for your interest in iB Cricket.'
                }}
              />
              <SecondaryThankYouText
                dangerouslySetInnerHTML={{
                  __html:
                    'Your response has been recorded. We will get back to you once the COVID 19 pandemic is under control and things get back to normal.<br/>Stay Safe!'
                }}
              />
            </SuccessText>
            <Button
              type="button"
              onClick={this.goBack}
              id="ownAFranchiseFormOkButton"
            >
              {'OK'}
            </Button>
          </SuccessContainer>
        </ResponsiveContainer>
      )
    }
    return (
      <ApplyForFormSection>
        <Heading as="div">{formHeading}</Heading>
        {glsLoaded ? (
          <FormContainer id="ExperientialMarketingForm" autocomplete="off">
            <InputComponent
              type="text"
              placeholder="First Name"
              required={required}
              validate={isRequired}
              innerRef={this.storeNameRef}
              onChange={this.handleChange}
            />
            <InputComponent
              type="text"
              placeholder="Last Name"
              required={required}
              validate={isRequired}
              innerRef={this.storeLastNameRef}
              onChange={this.handleChange}
            />
            <InputComponent
              type="text"
              placeholder={phoneNumberFieldPlaceholder}
              required={required}
              validate={isValidInternationalPhoneNumber}
              innerRef={this.storePhoneRef}
              onChange={this.handleChange}
            />

            <InputComponent
              type="text"
              placeholder={emailFieldPlaceholder}
              required={required}
              validate={isValidEmailIdWithOutRequired}
              innerRef={this.storeEmailRef}
              onChange={this.handleChange}
            />

            <InputComponent
              type="text"
              placeholder="Designation"
              required={required}
              validate={isRequired}
              innerRef={this.storeDesignationRef}
              onChange={this.handleChange}
            />
            <InputComponent
              type="text"
              placeholder="Organisation"
              required={required}
              validate={isRequired}
              innerRef={this.storeOrganisationRef}
              onChange={this.handleChange}
            />
            <LocationSearchInput
              submissionStatus={submissionStatus}
              ref={this.storeCityRef}
              cityPlaceHolderText="City"
              handleChange={this.handleChange}
              glsLoaded={glsLoaded}
              inputType="fullInput"
              suggestionsContainerWidth="521px"
              fullInput
            />
            <WhyAreYouInterestedHeading>
              {'What are you looking to create together with iB Cricket'}
            </WhyAreYouInterestedHeading>
            <TextAreaComponent
              type="textarea"
              placeholder=""
              required={required}
              validate={isRequired}
              innerRef={this.storeWhatAreYouLookingForRef}
              onChange={this.handleChange}
              className="fullInput"
            />
            <div>
              <ButtonWrapper>
                <Button
                  type="submit"
                  onClick={this.handleSubmit}
                  id="ownAFranchiseFormSubmitButton"
                  as="button"
                >
                  SUBMIT
                </Button>
              </ButtonWrapper>
            </div>
          </FormContainer>
        ) : (
          <Loading>Loading ... </Loading>
        )}
      </ApplyForFormSection>
    )
  }
}

export default ApplyForFranchiseAgentForm



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowModal/ApplyForFranchiseAgentForm/index.js